<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} USER</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">


           <!-- Product Image -->
           <template >
             <!-- Image Container -->
                <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">
            <img v-if="checkImg" :src="dataImg" class="responsive">
          </div>
          </div>
            </div>
             <!-- Image upload Buttons -->
             <div class="modify-img flex justify-between mt-5">
               <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
               <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} Image</vs-button>
             <vs-button v-if="ImgName!==null" type="flat" color="#999" @click="ImgName = null , dataImg = null">Remove Image</vs-button>
             </div>
           </template>
              <!-- Username-->
        <vs-input label="Username *" v-model="dataUserName" @input="checkUserName" class="mt-5 w-full" name="Username" v-validate="'alpha_num'" />
        <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">UserName has  already been taken!</span>



        <!-- FIRST NAME -->
        <vs-input label="First Name *" v-model="dataFirstName" class="mt-5 w-full" name="First Name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
          <!-- Middle NAME -->
        <vs-input label="Middle Name" v-model="dataMiddleName" class="mt-5 w-full" name="item-middle-name"  />


        <!-- LAST NAME -->
        <vs-input label="Last Name *" v-model="dataLastName" class="mt-5 w-full" name="Last Name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>




        <!-- PHONE -->
        <vs-input label="Phone" v-model="dataPhone" @input="acceptNumber" class="mt-5 w-full" name="Phone"/>
        <span v-if="dataPhone.length > 0 &&  dataPhone.length < 14" class="text-danger text-sm">Invalid phone number format.</span>
        <span class="text-danger text-sm" v-show="errors.has('Phone')">{{ errors.first('Phone') }}</span>
        <!-- ROLES -->
        <!-- EMAIL -->
        <vs-input label="Email *" @input="checkUserEmail" v-model="dataEmail" class="mt-5 w-full" name="email"
                  v-validate="'email|required'"/>
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        <span class="text-danger text-sm" v-if="emailDuplicate>0">Email has already been taken!</span>
        <br>
        <label class="vs-select--label w-full">Role</label>
        <ul class="centerx mt-2  flex flex-wrap">
          <li class="ml-1" v-for="role in rolesList" :key="role.id">
            <vs-radio v-model="dataRole" :vs-value="role.id">{{ role.name }}</vs-radio>
          </li>
        </ul>


        <!-- Send Invite Email -->
        <br>

        <vs-checkbox v-show="enableInvitOption" v-model="dataEmailInviteOption"
                     @change="changeEmailConfirmationStatus(dataEmailInviteOption)">Send Invite Email
        </vs-checkbox>


        <div v-if="!dataEmailInviteOption">
          <vs-input
            ref="password"
            type="password"
            data-vv-validate-on="blur"
            v-validate="'required|min:6|max:20'"
            name="password"
            label-placeholder="Password"
            placeholder="Password"
            v-model="dataPassword"
            class="w-full mt-6" />
          <span class="text-danger text-sm">{{ errors.first('password') }}</span>

          <vs-input
            type="password"
            v-validate="'min:6|max:20|confirmed:password'"
            data-vv-validate-on="blur"
            data-vv-as="password"
            name="confirm_password"
            label-placeholder="Confirm Password"
            placeholder="Confirm Password"
            v-model="dataConfPassword"
            class="w-full mt-6" />
          <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

        </div>


<!--        <vs-row vs-w="12" class="ml-6">-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="2">-->
<!--            <label>Email Confirmed</label>-->
<!--          </vs-col>-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="8">-->
<!--          </vs-col>-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">-->
<!--            <vs-switch v-model="isEmailConfirmed" @change="changeInviteEmailStatus(isEmailConfirmed)"></vs-switch>-->
<!--          </vs-col>-->
<!--        </vs-row>-->
        <br>
        <vs-row vs-w="12" class="ml-6">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="2" vs-xs="1">
            <label>Status</label>
          </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="9">
        </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">
          <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row>


      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from "vue-select";
import {
  ADMIN_ROLES_LIST,
  CHECK_USER_EMAIL,
  CHECK_USER_NAME_EXCEPT_ID,
  CREATE_ADMIN,
  SINGLE_USER_BY_EMAIL,
  SINGLE_USER_BY_USERNAME,
  UPDATE_ADMIN,
  UPLOAD_IMAGE
} from '@/graphql'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,

    },
    data: {
      type: Object,
      default: () => {}
    },

  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      ImgName:'',
      img_cdn:'',
      rolesList: [],
      dataRole: [],
      emailDuplicate:0,
      UserDuplicate:0,
      alphanumeric:0,
      enableInvitOption:true,
      dataId: null,
      dataUserName: '',
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataImg:'',
      dataImgUrl:'',
      dataEmail: '',
      dataPhone: '',
      dataStudent: '',
      dataStatus: false,
      checkImg:'',
      dataPassword: '',
      dataConfPassword: '',
      dataEmailInviteOption:true,
      isEmailConfirmed: false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.enableInvitOption = true
      } else {
        const { id, username, fname, lname, middle_name, status, email, phone, students, avatar,email_confirmed,roles } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.checkImg = avatar
        this.dataUserName = username
        this.dataFirstName = fname
        this.dataMiddleName = middle_name
        this.dataLastName = lname
        this.dataImg = this.img_cdn+avatar
        this.oldimage = avatar
        this.ImgName = avatar
        this.dataEmail = email
        this.dataPhone = phone
        if(!this.dataPhone){
          this.dataPhone=''
        }
        this.dataStudent = students
        this.dataRole = roles.map(function (value, index) {
          return value.id;
        });
        this.dataStatus = status
        this.isEmailConfirmed = email_confirmed
        this.dataPassword = ''
        this.dataConfPassword = ''
        this.enableInvitOption = false
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail  && this.emailDuplicate===0 && this.UserDuplicate===0 && this.alphanumeric===0  && this.dataRole.length!=0 && (this.dataPhone =='' || this.dataPhone.length ==14)
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
     openLoadingInDiv(){
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    changeEmailConfirmationStatus(val) {
      this.isEmailConfirmed = !val
      this.dataPassword=''
      this.dataConfPassword=''
    },
    changeInviteEmailStatus(val) {
      this.dataEmailInviteOption = !val
    },
     StatusSuccess() {
      this.$vs.notify({
        title: "User",
        text: 'User Added Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusFail() {
      this.$vs.notify({
        title: "User",
        text: 'Failed to add User!',
        color: 'danger',
        position: 'top-right'
      })
    },
     UpdateSuccess() {
      this.$vs.notify({
        title: "User",
        text: 'User Update Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    UpdateFail() {
      this.$vs.notify({
        title: "User",
        text: 'Failed to Update!',
        color: 'danger',
        position: 'top-right'
      })
      },
    checkUserName() {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkUserNameExcepteId();
      } else {
        this.checkUserNameWithoutId()
      }
    },
    checkUserNameExcepteId() {
      var letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else {
        if (this.dataUserName) {
          this.$apollo
            .mutate({
              mutation: CHECK_USER_NAME_EXCEPT_ID,
              variables: {
                id: this.dataId,
                username: this.dataUserName,
              },
            })
            .then(response => {
              this.UserDuplicate=response.data.checkUserNameExceptId.length
            })
        }
      }
    },
    checkUserNameWithoutId() {
      var letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else {
        if (this.dataUserName) {
          this.$apollo
            .mutate({
              mutation: SINGLE_USER_BY_USERNAME,
              variables: {
                username: this.dataUserName,
              },
            })
            .then(response => {
              this.UserDuplicate=response.data.userByUserName.length
            })
        }
      }
    },

    checkUserEmail() {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkEmailExceptId();
      } else {
        this.checkEmailWithoutId()
      }
    },

    checkEmailExceptId() {
      this.$apollo
        .mutate({
          mutation: CHECK_USER_EMAIL,
          variables: {
            id: this.dataId,
            email: this.dataEmail,
          },
        })
        .then(response => {
          this.emailDuplicate = response.data.checkUserEmail.length
        })
    },
    checkEmailWithoutId() {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataEmail,
          },
        })
        .then(response => {
          this.emailDuplicate = response.data.userByEmail.length
        })
    },

    acceptNumber() {
      let x = this.dataPhone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

      this.dataPhone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataFirstName = ''
      this.dataLastName = ''
      this.dataUserName = ''
      this.dataMiddleName = ''
      this.dataImg = null
      this.ImgName = null
      this.dataStudent = ''
      this.dataStatus = false
      this.isEmailConfirmed = false
      this.dataEmail = ''
      this.dataPhone = ''
      this.dataRole = []
      this.checkImg=''
      this.dataPassword = ''
      this.dataConfPassword = ''

    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
          .mutate({
           mutation: UPDATE_ADMIN,
          variables: {
            id: this.dataId,
            fname: this.dataFirstName,
            middle_name: this.dataMiddleName,
            lname: this.dataLastName,
            username: this.dataUserName,
            phone: this.dataPhone,
            status: this.dataStatus,
            avatar:this.ImgName,
            roles: this.dataRole,

          }
          })
              .then(response => {
                if (response) {
                  this.UpdateSuccess()

                }
              }).catch(error => {
              console.log(error)
            });

          } else {

            this.$apollo
          .mutate({
            mutation: CREATE_ADMIN,
            variables: {
              fname: this.dataFirstName,
              middle_name: this.dataMiddleName,
              lname: this.dataLastName,
              username: this.dataUserName,
              phone: this.dataPhone,
              email: this.dataEmail,
              email_confirmed: true,
              status: this.dataStatus,
              avatar:this.ImgName,
              invite_email: this.dataEmailInviteOption,
              roles: this.dataRole,
              password: this.dataPassword,

          }
        })
        .then(response => {
          if (response){
            this.StatusSuccess()
          }
        }) .catch(error => {
          this.StatusFail()
          console.log(error)
      });
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        this.checkImg="somthing"
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
           this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image:this.dataImg,
                oldimage:this.oldimage,
              }
            })
            .then(response => {
              if (response){
                this.oldimage=''
                if(response.data.uploadImage.status=="SUCCESS"){
                  this.ImgName = response.data.uploadImage.image_name
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                }
                else{
                  this.ImgName = response.data.uploadImage.image_name
                  this.UploadFail(response.data.uploadImage.error)
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                }

              }
            }) .catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  created() {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
      this.$apollo
        .mutate({
          mutation: ADMIN_ROLES_LIST,
        })
        .then(response => {
          this.rolesList=response.data.getAdminRolesList

        })


  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
